import { render, staticRenderFns } from "./OrderTime.vue?vue&type=template&id=4f5ae598&scoped=true"
import script from "./OrderTime.vue?vue&type=script&lang=js"
export * from "./OrderTime.vue?vue&type=script&lang=js"
import style0 from "./OrderTime.vue?vue&type=style&index=0&id=4f5ae598&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5ae598",
  null
  
)

export default component.exports